import { ReactComponent as LoaderSvg } from '../assets/loader.svg';

interface propTypes {
  color?: string;
  size?: number;
  wrapperClass?: string;
  absolute?: boolean;
}

export const Loader = ({
  size = 100,
  color = '#004561',
  wrapperClass = '',
  absolute = false

}: propTypes) => {

  return (
    <div className={`h-full w-full grid place-items-center ${wrapperClass} ${absolute ? 'absolute' : ''}`}>
      <LoaderSvg fill={color} width={`${size}px`} height={`${size}px` } style={{background: 'none'}} />
    </div>
  )
}
